import dateFormatter from '../../../components/valueFormatter/dateFormatter';
import dateTimeFormatter from '../../../components/valueFormatter/dateTimeFormatter';
import updatedByFilterValueGetter from '../../../components/filterValueGetter/updatedByFilterValueGetter';
import createdByFilterValueGetter from '../../../components/filterValueGetter/createdByFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import type { TFunction } from 'i18next';
import type { ColDef } from 'ag-grid-community';

const useColdefManageNews = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsRenderer',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      width: 90,
    },
    {
      field: 'order',
      headerName: t('information.order'),
      headerTooltip: t('information.order'),
      minWidth: 70,
      maxWidth: 70,
    },
    {
      field: 'isDraft',
      headerName: t('information.draft'),
      headerTooltip: t('information.draft'),
      cellRenderer: 'booleanRenderer',
      minWidth: 50,
      maxWidth: 50,
    },
    {
      field: 'title',
      headerName: t('information.title'),
      headerTooltip: t('information.title'),
    },
    {
      field: 'message',
      headerName: t('information.message'),
      headerTooltip: t('information.message'),
    },
    {
      field: 'publicationStartAt',
      headerName: t('information.news.publicationStart'),
      headerTooltip: t('information.news.publicationStart'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'publicationEndAt',
      headerName: t('information.news.publicationEnd'),
      headerTooltip: t('information.news.publicationEnd'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateFormatter,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: 'updatedAt',
      headerName: t('grid.updatedAt'),
      headerTooltip: t('grid.updatedAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'updatedBy',
      headerName: t('grid.updatedBy'),
      headerTooltip: t('grid.updatedBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: updatedByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
    {
      field: 'createdAt',
      headerName: t('grid.createdAt'),
      headerTooltip: t('grid.createdAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'createdBy',
      headerName: t('grid.createdBy'),
      headerTooltip: t('grid.createdBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: createdByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
  ];

  return colDefs;
};

export default useColdefManageNews;
